import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link, useParams, useNavigate } from "react-router-dom";
import { Card, Form, Row, Col, Spinner } from "react-bootstrap";
import Swal from "sweetalert2";
import { BASE_URL } from "../../services/Api";
import { authHeader } from "../../services/auth-header";

const AddContact = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { pointindex } = useParams();
  const [contactname, setContactname] = useState("");
  const [companyname, setCompanyname] = useState("");
  const [mobileno, setMobileno] = useState("");
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const customerResponse = await axios.get(`${BASE_URL}customer/findById/${id}`, {
          headers: authHeader(),
        });
        const customerData = customerResponse.data;
        setCompanyname(customerData.companyname);
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Failed to fetch customer details. Please try again.',
        });
      }
    };

    fetchData();
  }, [id]);

  const handleSubmit = async () => {
    setIsLoading(true);

    const customerData = {
      contactname,
      companyname,
      mobileno,
      email,
      customer: { id }
    };
    console.log('amit', customerData);
    try {
      const response = await axios.post(`${BASE_URL}CustomerContactPerson/save`, customerData, {
        headers: authHeader(),
      });
      console.log('amit', response.data);
      Swal.fire({
        icon: 'success',
        title: 'Success',
        text: 'Customer updated successfully!',
      });
      navigate(`/contactTable/${id}/${pointindex}`);
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: error.response?.data?.message || 'An error occurred. Please try again.',
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="Container">
      <Card className="card">
        <Card.Header className="card-header">
          <h6> ADD CONTACT</h6>
          <Link to={`/contactTable/${id}/${pointindex}`}>
            <button className="button-70">BACK</button>
          </Link>
        </Card.Header>
        <Card.Body>
          <Form>
            <Row>
              <Col md="6">
                <Form.Group controlId="formCompanyname">
                  <Form.Label>Company Name</Form.Label>
                  <Form.Control
                    type="text"
                    value={companyname}
                    onChange={(e) => setCompanyname(e.target.value)}
                    disabled
                  />
                </Form.Group>
              </Col>
              <Col md="6">
                <Form.Group controlId="formContactname">
                  <Form.Label>Contact Name</Form.Label>
                  <Form.Control
                    type="text"
                    value={contactname}
                    onChange={(e) => setContactname(e.target.value)}
                  />
                </Form.Group>
              </Col>

              <Col md="6">
                <Form.Group controlId="formMobileno">
                  <Form.Label>Mobile Number</Form.Label>
                  <Form.Control
                    type="text"
                    value={mobileno}
                    onChange={(e) => setMobileno(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col md="6">
                <Form.Group controlId="formEmail">
                  <Form.Label>Email</Form.Label>
                  <Form.Control
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </Form.Group>
              </Col>
            </Row>
            <button
              className="button-70"
              type="button"
              onClick={handleSubmit}
              disabled={isLoading}
            >
              {isLoading ? <Spinner animation="border" size="sm" /> : 'SUBMIT'}
            </button>
          </Form>
        </Card.Body>
      </Card>
    </div>
  );
};

export default AddContact;

